import React from 'react';
import { motion } from 'framer-motion';
import './Features.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"/>
        <path d="M12 6v6l4 2"/>
      </svg>
    ),
    title: '24/7 AI Coach',
    description: 'Chat anytime with an AI that has full context of your fitness journey. Ask "Why am I not losing weight?" and get answers based on YOUR actual data.',
    gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 6h16M4 12h16M4 18h10"/>
        <circle cx="19" cy="18" r="3"/>
      </svg>
    ),
    title: 'AI-Generated Workouts',
    description: 'Custom workout plans tailored to your equipment, experience level, schedule, and goals. The AI adapts based on your progress and feedback.',
    gradient: 'linear-gradient(135deg, #f093fb, #f5576c)'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    title: 'Smart Food Logging',
    description: 'Describe any meal in natural language and AI instantly finds nutritional info. Say "chicken salad with ranch" and it logs everything.',
    gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 12a9 9 0 1 1-9-9"/>
        <path d="M21 3v6h-6"/>
        <path d="M12 7v5l3 3"/>
      </svg>
    ),
    title: 'Personalized Insights',
    description: 'AI analyzes your data to spot trends, suggest adjustments, and predict plateaus before they happen. Stay ahead of your progress.',
    gradient: 'linear-gradient(135deg, #fa709a, #fee140)'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18"/>
        <path d="M9 21V9"/>
      </svg>
    ),
    title: 'AI Macro Targets',
    description: 'Automatically calculated nutrition goals based on your body stats, activity level, and objectives - adjusted dynamically as you progress.',
    gradient: 'linear-gradient(135deg, #a8edea, #fed6e3)'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
    title: 'Privacy First',
    description: 'Your data trains your experience, not sold to anyone. Complete privacy with all your fitness information staying secure and personal.',
    gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

function Features() {
  return (
    <section id="features" className="features">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <h2>AI-Powered Features</h2>
          <p>Everything you need to transform your fitness journey, powered by intelligent AI that learns from your data.</p>
        </motion.div>

        <motion.div 
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              variants={itemVariants}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
            >
              <div className="feature-icon" style={{ background: feature.gradient }}>
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Features;
